var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWait({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    fill: "#FAD987",
    stroke: "#FFB258"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5998 11.2C20.6004 11.9953 20.3752 12.7745 19.9503 13.4469C19.5255 14.1192 18.9184 14.6571 18.1998 14.998L18.1998 17.002C18.9184 17.3429 19.5255 17.8808 19.9503 18.5531C20.3752 19.2255 20.6004 20.0047 20.5998 20.8L21.7998 20.8L21.7998 22L10.9998 22L10.9998 20.8L12.1998 20.8C12.1992 20.0047 12.4244 19.2255 12.8493 18.5531C13.2742 17.8808 13.8812 17.3429 14.5998 17.002L14.5998 14.998C13.8812 14.6571 13.2742 14.1192 12.8493 13.4469C12.4244 12.7745 12.1992 11.9953 12.1998 11.2L10.9998 11.2L10.9998 10L21.7998 10L21.7998 11.2L20.5998 11.2ZM19.3998 20.8C19.3999 20.1084 19.1611 19.438 18.7238 18.9023C18.2864 18.3665 17.6774 17.9983 16.9998 17.86L16.9998 16L15.7998 16L15.7998 17.86C15.1222 17.9983 14.5132 18.3665 14.0758 18.9023C13.6385 19.438 13.3997 20.1084 13.3998 20.8L19.3998 20.8Z",
    fill: "#F48A0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.f838814264b103aafcda7dbc9d4b30b3.svg";
export { ForwardRef as ReactComponent };